import { ApplicationSensitivity } from '../enums/application-sensitivity.enum';
import { ApplicationStatus } from '../enums/application-status.enum';
import { Client } from './client';

// TODO
// Can create applications: OpenIdUserManagement, OpenIdClientManagement
// Can read applications: same
// Can update applications: same
// Can create clients: OpenIdClientManagement,

export class Application {
  public id: string;
  public name: string;
  public description: string;
  public sensitivity: ApplicationSensitivity;
  public authMaxAge: number;
  public status: ApplicationStatus;

  public clients: Client[] = [];

  constructor(backEndApplication?: BackEndApplication) {
    if (backEndApplication) {
      this.id = backEndApplication.id;
      this.name = backEndApplication.name;
      this.description = backEndApplication.description;
      this.sensitivity = backEndApplication.sensitivity;
      this.authMaxAge = backEndApplication.auth_max_age;
      this.status = backEndApplication.status;
    }
  }

  public toBackEnd(): BackEndApplication {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      sensitivity: this.sensitivity,
      auth_max_age: this.authMaxAge,
      status: this.status,
    };
  }
}

export interface BackEndApplication {
  id: string;
  name: string;
  description: string;
  sensitivity: ApplicationSensitivity;
  auth_max_age: number;
  status: ApplicationStatus;
}
